import { Card } from 'antd';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AppCardList, DomainPunycode } from '../../../../../common/components';
import { AppRoutes } from '../../../../../common/interfaces';
import { CommonContainerTitle } from '../../../../../common/layouts/Common';
import { Domain } from '../../../entities';

interface Props {
  siteId: string;
  currentPage: number;
  siteDomainsItems: Pick<Domain, 'id' | 'name'>[];
  siteDomainsTotalItems: number;
  siteDomainsItemsPerPage: number;
  isLoading: boolean;
  handleChangePage: (page: number) => void;
  handleBack: () => void;
}

export const SitemapDomainsListView: FC<Props> = ({
  siteId,
  currentPage,
  siteDomainsItems,
  siteDomainsTotalItems,
  siteDomainsItemsPerPage,
  isLoading,
  handleChangePage,
  handleBack
}) => {
  const navigate = useNavigate();
  const domainId = useParams()['*'];

  return (
    <>
      <CommonContainerTitle onBack={ handleBack }>Файли індексації</CommonContainerTitle>

      <Card>
        <AppCardList
          headerTitle={ null }
          pagination={{
            current: currentPage,
            total: siteDomainsTotalItems,
            pageSize: siteDomainsItemsPerPage,
            disabled: isLoading,
            onChange: (page: number) => handleChangePage(page)
          }}
          selectedKey={ domainId }
          rowKey="id"
          titleKey="name"
          grid={{
            gutter: 16,
            xs: 1,
            sm: 1,
            md: 1,
            lg: 2,
            xl: 2,
            xxl: 2
          }}
          navigateTo={ (record) => ({ to: AppRoutes.SitemapById.replace(':siteId', siteId).replace(':domainId', record.id) }) }
          list={ siteDomainsItems }
          titleRender={ (title) => <DomainPunycode domainName={ title }/> }
          // content={ (record) => (
          //   <Flex align="center">
          //     <span style={{ fontFamily: 'monospace' }}>robots.txt:</span>&nbsp;
          //     { record.robots ? <CheckCircleFill color={ token.colorSuccess }/> : <XCircleFill color={ token.colorWarning }/> }
          //   </Flex>
          // ) }
        />
      </Card>
    </>
  );
};
